import { Reducer } from "redux";

import { BcbsTnSAMLResponse } from "../models/api/User";
import { Bcbs_Tn_SSO_ActionTypes } from "../models/dispatchTypes/User";
import { Bcbs_Tn_SSO_ActionDispatchTypes } from "../constants/User";

const initialState: BcbsTnSAMLResponse = {
  loading: false,
  response: null,
  error: null,
};

const BcbsTnSAMLReducer: Reducer<
  BcbsTnSAMLResponse,
  Bcbs_Tn_SSO_ActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case Bcbs_Tn_SSO_ActionDispatchTypes.BCBS_TN_SSO_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case Bcbs_Tn_SSO_ActionDispatchTypes.BCBS_TN_SSO_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case Bcbs_Tn_SSO_ActionDispatchTypes.BCBS_TN_SSO_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case Bcbs_Tn_SSO_ActionDispatchTypes.BCBS_TN_SSO_RESET: {
      return initialState;
    }
  }
  return state;
};

export default BcbsTnSAMLReducer;
